import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FilterHeader = ({ categoryName, totalResults }) => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate('/home-screen');
    };

    return (
        <header className="sticky top-0 z-50 bg-background border-b border-border">
            <div className="content-container">
                <div className="flex items-center gap-4 py-4 md:py-5">
                    <button
                        onClick={handleBackClick}
                        className="touch-target flex items-center justify-center w-10 h-10 rounded-lg bg-card hover:bg-muted transition-all duration-200 tap-highlight-none"
                        aria-label="Go back to home"
                    >
                        <Icon name="ArrowLeft" size={20} strokeWidth={2.5} />
                    </button>

                    <div className="flex-1">
                        <h1 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground">
                            {categoryName}
                        </h1>
                        <p className="text-sm md:text-base text-muted-foreground mt-0.5">
                            {totalResults} {totalResults === 1 ? 'vendor' : 'vendors'} available
                        </p>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default FilterHeader;